import React from 'react';
import styled from '@emotion/styled';
import { CommentHistoryWrapper } from '@seedlang/hoc';
import PlainPageHeading from 'components/plain_page_heading';
import Link from 'components/link';
import Button from 'components/button/button';
import Spinner from 'components/spinner';
import Paginator from 'components/paginator';

const Row = styled(Link)`
  display: block;
  padding: 15px 15px 15px 0;
  color: #333;
  background: transparent;
  transition: background-color 120ms ease;
  & + & {
    border-top: 1px solid #e5e5e5;
  }
  &:hover {
    background: #f7f7f7;
  }
`;

const Title = styled.div`
  font-weight: bold;
  margin-bottom: 8px;
`;

const Preview = styled.div`
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  overflow-wrap: anywhere;
  white-space: pre-wrap;
`;

const Date = styled.div`
  color: #777;
  font-size: 13px;
  margin-top: 8px;
`;

const CommentHistory = props => (
  <>
    <PlainPageHeading contentGap={15}>Comment History</PlainPageHeading>
    {props.loading && <Spinner />}
    {props.loadFailed ? (
      <>
        <p>Sorry, we couldn&apos;t load your comment history.</p>
        <Button onClick={() => props.onLoadPage(props.page)}>Try Again</Button>
      </>
    ) : (
      <>
        {props.loaded && !props.loading && !props.comments.length && <p>You haven&apos;t written any comments yet.</p>}
        {props.comments.map(comment => (
          <Row
            key={comment.id}
            to={`/discussions/${comment.forumId}/threads/${comment.forumThreadId}#comment-${comment.id}`}
          >
            <Title>{comment.forumThreadTitle}</Title>
            <Preview>{comment.text}</Preview>
            <Date>{comment.createdAt?.formattedDateWithYearAndTime}</Date>
          </Row>
        ))}
      </>
    )}
    {props.pagesCount > 1 && (
      <Paginator
        store={props.store}
        ids={{ userId: props.userId }}
        queryStrings={{ history: true }}
        onClickScrollToTop
        withSpinner
      />
    )}
  </>
);

export default CommentHistoryWrapper(CommentHistory);
